import { AppService } from './app.service';
import { ProfileService } from './profile.service';

export * from './app.service';

export const services = [AppService, ProfileService];
